<vpfa-notifications-container></vpfa-notifications-container>
<vpfa-loading [noTopMenu]="true" [loadingStateOverride]="shouldShowLoadingIndicator$ | async">
  <router-outlet [hidden]="isNavigationInProgress$"></router-outlet>
</vpfa-loading>
<vpfa-footer></vpfa-footer>
